import { apiClient } from "../apiClient";

const HINH_THUC_THI_ENDPOINT = "hinh-thuc-thi";
export const hinhThucThiApi = {
    SelectAll: () => apiClient.get(`${HINH_THUC_THI_ENDPOINT}`),
}